<template>
	<div id="main_wrap">
		<router-view></router-view>
	</div>
</template>

<script>
	
	export default {
		name: 'index',
		data() {
			return {
				
			}
		}
		}
		
</script>

<style>
</style>


// WEBPACK FOOTER //
// main_page.vue?3e7adc53